import TensaiLogo from "../../assets/icons/tensai-logo.svg";
import BackgroundImage from "../../assets/images/background-cover.png";

import {
  Container,
  ImageContent,
  Content,
  Header,
  Logo,
  FooterOfCover,
  FooterDescription,
  FooterDescriptionStronger,
} from "./styles";

function Cover() {
  return (
    <Container className="page">
      <ImageContent alt="Background" src={BackgroundImage} />
      <Content>
        <Header>
          <Logo alt="Tensai" src={TensaiLogo} />
        </Header>

        <FooterOfCover>
          <FooterDescription>
            Relatório de&nbsp;
            <FooterDescriptionStronger>
              distribuição de amostras
            </FooterDescriptionStronger>
          </FooterDescription>
        </FooterOfCover>
      </Content>
    </Container>
  );
}

export default Cover;
